import React, { FC } from "react"
import { Button } from "antd"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { URL_INTEREST_DETAILS } from "../../models/url"
import { parentScrollToOffset } from "../../helpers/parentIFrame"
import { InterestListItem } from "./interestListData"

type InterestDetailsButtonProps = {
    list: InterestListItem
    block?: boolean
    style?: React.CSSProperties
}

/** Einheitlicher Listen-CTA für Tabelle, Grid und Mobile-Card. */
const InterestDetailsButton: FC<InterestDetailsButtonProps> = ({ list, block = true, style }) => {
    const history = useHistory()
    const { t } = useTranslation()

    const openDetails = () => {
        parentScrollToOffset(0, 0)
        history.push(URL_INTEREST_DETAILS.replace(":id", list.id))
    }

    return (
        <Button type='primary' block={block} style={style} disabled={list.isFull} data-testid='interest-cta' onClick={openDetails}>
            {list.isFull ? t("interest.ctaFull", "Liste ist voll") : t("interest.cta", "Details & Interesse")}
        </Button>
    )
}

export default InterestDetailsButton
